import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CountryDto } from "../../../../dtos/catalogs/country/CountryDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import CountryDetailSkeleton from "./CountryDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { useTranslation } from "react-i18next";

interface IProps {
  model: CountryDto | null;
  modelUpdatedEvent: (newModel: CountryDto) => void;
}

interface CountryModel {
  id: string;
  name: string;
  createdDate: Date;
}

export const CountryDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<CountryModel>();
  const { t } = useTranslation();
  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("createdDate", model.createdDate);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: CountryModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: CountryDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <CountryDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>
        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={t("Name")} fieldName={"name"} />
            </Col>
            <Col sm={6}>
              <NFTextInput title={t("Unique code")} fieldName={"uniqueCode"} />
            </Col>
          </Row>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
